/**
 * 定义路径s
 */
const PATH = 'menu_'
/*
包含n个mutation的type名称常量
 */
export const MENU_CHANGE = PATH + 'change'
export const MENU_INIT = PATH + 'init'



// WEBPACK FOOTER //
// ./src/store/mutations/menu/type.js